@if (spinner) {
<app-spinner></app-spinner>
}

<div class="request-control">
  <div class="right-side">
    @if (filterData) {
      <app-filter
        [filterData]="filterData"
        [filterDataInit]="filterDataInit"
        [filterPage]="filterPage"
        (formValus)="filterFormValues($event)"
      ></app-filter>
    }
    <quick-search
      [placeholder]="'البحث'"
      (searchResults)="quickSearch($any($event))"
    ></quick-search>
  </div>

  <div class="new-element">
    <button class="btn btn-add" (click)="addSpecialty()">
      <img src="assets/images/svg/add-icon.svg" alt="" />
      إضافة تخصص
    </button>
  </div>
</div>

@if (specialties.length > 0) {
<div class="request-table">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="col-id">رقم التخصص</th>
          <th class="col-name">اسم التخصص</th>
          <th class="col-groups">المجموعات</th>
          <th class="col-date">تاريخ الانشاء</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        @for (item of specialties; track item.id) {
          <tr>
            <td>#{{ item.id }}</td>
            <td>{{ item.name_ar }}</td>
            <td>{{ item.cohorts_count }}</td>
            <td>{{ item.created_at | date: 'yyyy/M/d' }}</td>
            <td class="actions-cell">
              <button class="btn btn-edit" type="button" (click)="editSpecialty(item)">
                <img src="assets/images/svg/edit-05.svg" alt="" width="18" height="18" />
                تعديل
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<ayen-pagination
  [id]="config.id"
  (pageData)="pageChanged($event)"
  (pageSize)="pageSizeChanged($event)"
  [totalCount]="config.totalItems"
  [itemsPerPage]="config.itemsPerPage"
  [currentPage]="config.currentPage">
</ayen-pagination>
} @else if (!spinner) {
<div class="no-data container">
  <p>لا توجد بيانات</p>
</div>
}
